(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-faqs"]) return;
  try {
    
  (() => {
    const initFaq = section => {
      if (!section || section.dataset.ougistFaqReady === 'true') return;
      section.dataset.ougistFaqReady = 'true';
      const input = section.querySelector('[data-ougist-faq-search]');
      const empty = section.querySelector('[data-ougist-faq-empty]');
      const items = Array.from(section.querySelectorAll('[data-ougist-faq-item]'));
      const groups = Array.from(section.querySelectorAll('[data-ougist-faq-group]'));
      const updateAria = item => {
        const heading = item.querySelector('.collapsible-heading');
        if (!heading) return;
        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');
      };
      items.forEach(item => {
        const heading = item.querySelector('.collapsible-heading');
        updateAria(item);
        if (!heading) return;
        heading.addEventListener('click', () => requestAnimationFrame(() => updateAria(item)));
        heading.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          heading.click();
        });
      });
      if (!input) return;
      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;
        items.forEach(item => {
          const matches = query === '' || item.textContent.toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });
        groups.forEach(group => {
          const hasVisibleItem = Array.from(group.querySelectorAll('[data-ougist-faq-item]')).some(item => !item.hidden);
          group.hidden = query !== '' && !hasVisibleItem;
        });
        if (empty) empty.hidden = query === '' || visibleCount > 0;
      });
    };
    document.querySelectorAll('[data-ougist-faq-section]').forEach(initFaq);
    document.addEventListener('shopify:section:load', event => {
      const section = event.target.matches('[data-ougist-faq-section]')
        ? event.target
        : event.target.querySelector('[data-ougist-faq-section]');
      initFaq(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  } catch(e) { console.error(e); }
})();
})();
